import { render, staticRenderFns } from "./PrimarySection.vue?vue&type=template&id=12e5315c&"
import script from "./PrimarySection.vue?vue&type=script&lang=js&"
export * from "./PrimarySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports